import React from "react";
import dayjs from "dayjs";
import GenericReportPage from "../../../components/common/GenericReportPage";
import { fmtQty } from "../../../utils/reportExport";

// Statuses follow the material request workflow: Draft -> Pending -> Approved ->
// Accepted / Partially Accepted -> Issued / Completed (see material_request APIs).
const STATUS_OPTIONS = [
    { value: "", label: "All Status" },
    { value: "Draft", label: "Draft" },
    { value: "Pending", label: "Pending" },
    { value: "Approved", label: "Approved" },
    { value: "Accepted", label: "Accepted" },
    { value: "Partially Accepted", label: "Partially Accepted" },
    { value: "Issued", label: "Issued" },
    { value: "Completed", label: "Completed" },
    { value: "Rejected", label: "Rejected" },
];

const MaterialRequestsReport = () => (
    <GenericReportPage
        title="Material Requests Report"
        subtitle="Material requests with requester, items and quantities"
        breadcrumb={["Reports", "Inventory"]}
        fetchUrl="/reports/inventory/material_requests.php"
        rowKey="mr_id"
        filterDefs={[
            { type: "search", key: "search", label: "Search", col: 6, placeholder: "MR ref, requester" },
            { type: "select", key: "status", label: "Status", col: 4, options: STATUS_OPTIONS },
            { type: "date", key: "dateRange", label: "Request Date", col: 6 },
        ]}
        columns={[
            { title: 'MR Ref', dataIndex: 'mr_ref', key: 'mr_ref', width: 130, sorter: (a, b) => (a.mr_ref || '').localeCompare(b.mr_ref || '') },
            { title: 'Request Date', dataIndex: 'request_date', key: 'request_date', width: 120, render: (d) => dayjs(d).format("YYYY-MM-DD"), sorter: (a, b) => dayjs(a.request_date).valueOf() - dayjs(b.request_date).valueOf() },
            { title: 'Required Date', dataIndex: 'required_date', key: 'required_date', width: 120, render: (d) => dayjs(d).format("YYYY-MM-DD") },
            { title: 'Items', dataIndex: 'item_count', key: 'item_count', align: 'center', width: 80 },
            { title: 'Total Qty', dataIndex: 'total_qty', key: 'total_qty', align: 'right', width: 100, render: (v) => fmtQty(v) },
            { title: 'Status', dataIndex: 'req_status', key: 'req_status', width: 140 },
            { title: 'Requester', dataIndex: 'requester_name', key: 'requester_name', width: 140 },
            { title: 'Approved By', dataIndex: 'approver_name', key: 'approver_name', width: 140, render: (v) => v || "—" },
        ]}
        pdf={{
            title: "MATERIAL REQUESTS REPORT",
            subtitle: "Material requests with requester, items and quantities",
            columns: [
                { header: "MR Ref" }, { header: "Request Date" }, { header: "Required Date" },
                { header: "Items", align: "center" }, { header: "Total Qty", align: "right" },
                { header: "Status" }, { header: "Requester" }, { header: "Approved By" },
            ],
            rows: (rows) =>
                rows.map((r) => [
                    r.mr_ref || "-",
                    dayjs(r.request_date).format("YYYY-MM-DD"),
                    dayjs(r.required_date).format("YYYY-MM-DD"),
                    String(r.item_count ?? ""),
                    fmtQty(r.total_qty),
                    r.req_status || "-",
                    r.requester_name || "-",
                    r.approver_name || "-",
                ]),
            columnStyles: { 4: { halign: "right" } },
        }}
        excel={{
            filename: "material-requests-report",
            sheetName: "Material Requests",
            columns: [
                { title: "MR Ref", dataIndex: "mr_ref", width: 16 },
                { title: "Request Date", dataIndex: "request_date", width: 13 },
                { title: "Required Date", dataIndex: "required_date", width: 13 },
                { title: "Items", dataIndex: "item_count", width: 8 },
                { title: "Total Qty", dataIndex: "total_qty", width: 10 },
                { title: "Status", dataIndex: "req_status", width: 16 },
                { title: "Requester", dataIndex: "requester_name", width: 18 },
                { title: "Approved By", dataIndex: "approver_name", width: 18 },
            ],
            rows: (rows) =>
                rows.map((r) => ({
                    ...r,
                    request_date: dayjs(r.request_date).format("YYYY-MM-DD"),
                    required_date: dayjs(r.required_date).format("YYYY-MM-DD"),
                    total_qty: fmtQty(r.total_qty),
                })),
        }}
    />
);

export default MaterialRequestsReport;
